import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { AiOutlineCloudUpload } from "react-icons/ai";
const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

function Previews(props) {
  const [files1, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: files => {
      setFiles(
        files.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      props.set(files);
    },
    // accept: props.accept,
  });
  if (props.value) {
    if (typeof props.value == "object") {
      props.value.map(item => {
        files1.push({ preview: item });
      });
    } else {
      files1.push({ preview: props.value });
    }
  }
  const thumbs = files1.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt={file.name} />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      files1.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files1]
  );

  return (
    <section
      style={{ cursor: "pointer", padding: 10 }}
      className={`container  p-2 rounded ${
        props.classNames ? props.classNames : ""
      }`}
    >
      <div
        {...getRootProps({ className: "dropzone" })}
        style={{
          border: "1px dashed #B7DEFF",
          borderRadius: "5px",
          backgroundColor: "#EFF7FD",
        }}
        className="d-flex justify-content-center align-items-center"
      >
        <input {...getInputProps()} accept={props.accept} />
        <p
          style={{
            margin: 0,
            padding: "12px 10px",
          }}
        >
          <span className=" ">
            <AiOutlineCloudUpload size={25} />
          </span>
          {/* <span> برای انتخاب فایل اینجا کلیک کنید</span> */}
        </p>
      </div>
      <aside style={thumbsContainer}>{thumbs}</aside>
    </section>
  );
}
export default Previews;
